export const environment = {
    production: false,
    apiBaseUrl: 'https://clientes-sacich.dev.thinkupc.com/api/'
};
